module.exports = __webpack_public_path__ + "static/media/mp.90eab4d6.png";